<template>
  <div>
    <div class="bto-sb-widget">
      <div v-if="showHeaderTitle" class="bto-sb-widget-title bto-sb-title-icon bto-sb-title-big">
        <span class="bto-app-icon bto-app-history"></span>
        <h3>{{ t("Mobile.MyBets") }}</h3>
      </div>
    </div>
    <div class="bto-sb-widget-wrap bto-sb-history-wrap">
      <!------------------------------------- Widget Match Nav ---------------------------------------->
      <div class="bto-sb-widget bto-sb-widget-main-nav bto-sb-widget-pills-nav">
        <div class="bto-sb-widget-content">
          <div class="bto-sb-scrolling-menu">
            <ul>
              <li
                :class="{ 'bto-sb-main-nav-active': tab.code === activeTab.code }"
                v-for="(tab, i) in TABS"
                :key="i">
                <a @click="changeTab(tab)">{{ t(tab.name) }}</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <!------------------------------------- END Widget Match Nav ---------------------------------------->
      <!------------------------------------- Widget Filter History ---------------------------------------->
      <div class="bto-sb-widget bto-sb-history-filter">
        <ul>
          <li>
            <label>{{ t("Mobile.Type") }}</label>
            <div class="bto-sb-form-select">
              <select v-model="activeMatchType">
                <option v-for="(mt, i) in MATCH_TYPES" :key="i" :value="mt.val">
                  {{ t(mt.text) }}
                </option>
              </select>
              <div class="bto-sb-form-select-arrow"></div>
            </div>
          </li>
          <li>
            <label>{{ t("BetSlip.From") }}</label>
            <span class="bto-sb-datepicker">
              <date-picker
                v-model="fromDate"
                :format="DATE_FORMAT"
                :lang="PLAYER_LANG"
                :clearable="true"
                :not-after="toDate">
                <i class="bto-app-date"></i>
              </date-picker>
            </span>
          </li>
          <li>
            <label>{{ t("BetSlip.To") }}</label>
            <span class="bto-sb-datepicker">
              <date-picker
                v-model="toDate"
                :format="DATE_FORMAT"
                :lang="PLAYER_LANG"
                :clearable="true"
                :not-before="fromDate"
                :not-after="Date.now()">
                <i class="bto-app-date"></i>
              </date-picker>
            </span>
          </li>
          <li>
            <button type="submit" class="bto-sb-form-btn" @click="getHistory()" :disabled="isLoading">
              {{ t("Mobile.show") }}
            </button>
          </li>
        </ul>
      </div>
      <!------------------------------------- END Widget Filter History ---------------------------------------->
      <!------------------------------------- Widget Widget History Bets ---------------------------------------->
      <empty-state
        v-if="myBets.length === 0"
        :message="emptyStateStatusMessage"
        :icon-class="emptyStateClass" />
      <div class="bto-sb-widget bto-sb-history">
        <div
          class="bto-sb-history-items"
          v-for="(bet, i) in myBets"
          :key="i"
          :id="myBets.length - 1 === i ? refId : null"
          @click="loadDetails(i, bet.betSlipGroupID)">
          <MyBetsInlineHeader @cashedOutBetToRemove="cashedOutBetToRemove" :type="'history'" :isOpened="isOpened(i)" :bet="bet" />
          <MyBetsInlineDetails
            :type="'history'"
            :betDetails="bet"
            :isOpened="isOpened(i)"
            :isLoading="isLoading" />
        </div>
      </div>
      <!------------------------------------- END Widget Widget History Bets ---------------------------------------->
    </div>
  </div>
</template>

<script>
  import store from '../../../../store/index';
  import Base from './base';
  import { userLoggedIn } from '@bto-services/user';
  import MybetsModel from '@/models/mybets/model-mybets';
  import { MATCH_TYPES, DATE_FORMAT } from '@/models/enums/mybets-const';
  import MybetsTabsService from '@/services/mybets/mybets-tabs-service';
  import { BETSLIP_STATUS } from 'bto-models/betslip';
  import MyBetsInlineDetails from '../mybet-details/my-bets-inline-details';
  import MyBetsInlineHeader from '../mybet-header/my-bets-inline-header';
  import { EmptyState, ICON_CLASS } from '../../empty-state';
  import { EVENT_BUS } from '@bto-services/event-bus';

  export default {
    name: 'MybetsInlineComponent',
    extends: Base,
    props: {
      refId: {
        type: String,
        default: '',
      },
    },
    components: {
      MyBetsInlineDetails,
      EmptyState,
      MyBetsInlineHeader,
    },
    data() {
      return {
        MATCH_TYPES,
        DATE_FORMAT,
        PLAYER_LANG: APP_SETTINGS.player.language,
        TABS: MybetsTabsService.getOrderedTabs(),
        toDate: null,
        fromDate: null,
        activeMatchType: null,
        openedDetails: [],
        emptyStateIcon: ICON_CLASS.MYBETS,
        loadingSpinner: ICON_CLASS.LOADING,
        showHeaderTitle: APP_SETTINGS.myBets.showHeaderTitle,
      };
    },
    created() {
      store.commit('hideAfterRouteWidgets');
      this.$parent.$on('elementInViewport', this.loadMore);

      this.pageSize = Math.ceil(document.body.clientHeight / 50);
      const itemsPerPage = +APP_SETTINGS.myBets.itemsPerPage;

      if (itemsPerPage > this.pageSize) {
        this.pageSize = itemsPerPage;
      }

      this.getMyBets();
    },
    destroyed() {
      this.$parent.$off('elementInViewport', this.loadMore);
    },
    computed: {
      emptyStateClass() {
        return this.isLoading ? this.loadingSpinner : this.emptyStateIcon;
      },
      emptyStateStatusMessage() {
        return this.isLoading ? this.t('Mobile.LoadingMore') : !userLoggedIn() ? this.t('Mobile.LoginToSeeBets') : this.t('M.MyBetsEmpty');
      },
    },
    methods: {
      loadMore() {
        this.currentPage += 1;
        this.getMyBets(true);
      },
      cashedOutBetToRemove(betId) {
        const bet = this.myBets.find(mb => mb.betSlipGroupID === betId);
        if (bet) {
          (bet.combinations || []).forEach(comb => {
            comb.combinationStatusId = BETSLIP_STATUS.CACHEDOUT;
            comb.combStatus = this.$translate.text('BetSlipStatusType.CachedOut');
          });
          bet.betSlipGroupStatusId = BETSLIP_STATUS.CACHEDOUT;
          bet.betSlipGroupStatus = this.$translate.text('BetSlipStatusType.CachedOut');
        }
      },
      showCashout(bet) {
        return bet.betSlipGroupStatusId === BETSLIP_STATUS.PLACED;
      },
      getMyBets(loadMore) {
        if (!loadMore) {
          const today = new Date();
          this.fromDate = new Date(today);
          this.fromDate.setDate(today.getDate() - 1);
          this.fromDate.setHours(0, 0, 0, 0);
          this.toDate = today;
          const dTab = (APP_SETTINGS.myBets.defaultTab || '').trim();
          this.activeTab = this.TABS.find(t => t.key === dTab) || this.TABS[0];
          if (APP_SETTINGS.myBets.resetDefaultDateFilters) {
            this.fromDate = null;
            this.toDate = null;
          }
        }
        this.getHistory(loadMore);
      },
      getHistory(loadMore) {
        if (!loadMore) {
          this.currentPage = 1;
          this.myBets = [];
          this.openedDetails = [];
        }
        if (!userLoggedIn()) {
          return;
        }
        let request = this.getBaseMybetsRequestService();
        request.getParams.type = this.activeMatchType;
        const fromDate = this.fromDate && new Date(Date.UTC(this.fromDate.getFullYear(), this.fromDate.getMonth(), this.fromDate.getDate(), 0, 0, 0, 0));
        const toDate = this.toDate && new Date(Date.UTC(this.toDate.getFullYear(), this.toDate.getMonth(), this.toDate.getDate(), 23, 59, 59, 999));
        request.getParams.fromDate = fromDate;
        request.getParams.toDate = toDate;

        this.isLoading = true;
        EVENT_BUS.$emit('toggleObserving', true);
        request.execute((resp) => {
          this.resetLoading();
          if (!(resp.data && resp.data.length) && !loadMore) {
            this.myBets = [];
            return;
          }
          const mapedData = resp.data.map(mb => new MybetsModel(mb));
          this.myBets = [...this.myBets, ...mapedData];
          EVENT_BUS.$emit('toggleObserving', mapedData.length < this.pageSize);
        }, this.resetLoading);
      },
      loadDetails(idx, betId) {
        if (this.openedDetails.includes(idx)) {
          const index = this.openedDetails.indexOf(idx);
          if (index > -1) {
            this.openedDetails.splice(index, 1);
          }
        } else {
          this.openedDetails.push(idx);
          this.getDetails(betId, true);
        }
      },
      isOpened(idx) {
        const index = this.openedDetails.indexOf(idx);
        if (index > -1) {
          return true;
        } else {
          return false;
        }
      },
    },
  };
</script>